<template>
  <div class="account">
    <Loading v-if="loading" />
    <div v-if="!loading" class="edit-form py-3">
      <v-layout column align-center>
        <account-card
          :account="account"
          :read_only="read_only"
          :account_creation="account_creation"
          @read_only_changed="update_read_only()"
          @update_account="update_account($event.account)"
          @delete_account="delete_account()"
          @enable_account="enable_account()"
          @create_account="create_account($event.account)"
        >
        </account-card>
      </v-layout>
      <confirm-modal
        ref="confirm"
        title="Disable?"
        confirm-btn-text="OK"
        cancel-btn-text="Cancel"
      >
        <div style="max-width: 350px">
          Are you sure you want to disable this account?
        </div>
      </confirm-modal>
    </div>
  </div>
</template>

<script>
import adminApi from "@/api/admin";
import store from "@/store/index";
import AccountCard from "@/components/account/AccountCard.vue";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Loading from "@/components/shared/Loading.vue";

export default {
  components: {
    AccountCard,
    ConfirmModal,
    Loading,
  },
  mounted() {
    this.get_account();
  },
  data() {
    return {
      user_info: store.state.user,
      loading: false,
      account: null,
      read_only: true,
      account_creation: false,
    };
  },
  watch: {
    $route() {
      this.get_account();
    },
  },
  methods: {
    update_read_only() {
      this.read_only = !this.read_only;
      if (this.read_only) {
        this.get_account();
      }
    },
    update_account(account) {
      this.loading = true;
      const updated = {
        name: account.name,
        internal: account.internal,
        sap: account.sap,
        cost_center: account.cost_center,
        contract_end: account.contract_end,
        contract_start: account.contract_start,
        sales_support_contacts: account.sales_support_contacts,
        limits: {
          annual_subscription_fee_limit:
            account.limits.annual_subscription_fee_limit,
          fresh_imagery_fee_limit: account.limits.fresh_imagery_fee_limit,
          standard_imagery_fee_limit: account.limits.standard_imagery_fee_limit,
          training_imagery_fee_limit: account.limits.training_imagery_fee_limit,
          tasking_imagery_fee_limit: account.limits.tasking_imagery_fee_limit,
        },
        pricing: {
          fresh_imagery_price: account.pricing.fresh_imagery_price,
          standard_imagery_price: account.pricing.standard_imagery_price,
          training_imagery_price: account.pricing.training_imagery_price,
          tasking_imagery_price: account.pricing.tasking_imagery_price,
        },
      };
      // API schema doesnt like null values
      if (updated.cost_center === null) {
        delete updated["cost_center"];
      }
      if (updated.sap === null) {
        delete updated["sap"];
      }

      const account_id = this.$route.params.account_id;
      return adminApi
        .patch_account(account_id, updated)
        .then(() => {
          this.read_only = true;
          this.account.active = true;
          this.get_account();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    enable_account() {
      this.loading = true;
      const account_id = this.$route.params.account_id;

      return adminApi
        .patch_account(account_id, {})
        .then(() => {
          this.read_only = true;
          this.account.active = true;
          this.get_account();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    async delete_account() {
      this.$refs.confirm.show().then((yes) => {
        if (yes) {
          this.loading = true;
          const account_id = this.$route.params.account_id;

          return adminApi
            .disable_account(account_id)
            .then(() => {
              this.read_only = true;
              this.account.active = false;
              this.get_account();
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    create_account(account) {
      this.loading = true;
      return adminApi
        .post_account(account)
        .then((response) => {
          this.read_only = true;
          this.account_creation = false;
          this.loading = false;
          this.$router.push({
            name: "account-details",
            params: { account_id: response.data.account.account_id },
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    get_account() {
      this.loading = true;
      const account_id = this.$route.params.account_id;
      if (account_id) {
        return adminApi
          .get_account(this.$route.params.account_id)
          .then((response) => {
            this.loading = false;
            this.account = response.data.account;
            this.read_only = true;
            this.account_creation = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.account = {
          sales_support_contacts: [],
          pricing: {},
          limits: {},
        };
        this.read_only = false;
        this.account_creation = true;
        this.loading = false;
      }
    },
  },
};
</script>
